import React, {
  forwardRef, memo, useContext, useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Dialog, DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck } from '@fortawesome/free-solid-svg-icons';
import ListerContext from '../../context';
import Buttons from '../../../../components/buttons';
import { SetPeriodButton } from './buttons';
import SearchInput from '../../../../components/MaterialUI/searchInput';

const DocListerCommandPanel = forwardRef(({
  children,
}, ref) => {
  const {
    actions,
    permissions,
    searchString,
    period,
    localFilter,
  } = useContext(ListerContext);
  const filterApplied = !!Object.keys(localFilter)
    .filter((k) => localFilter[k].use).length;
  const [delOpened, setDelOpened] = useState(false);
  return (
    <>
      <Stack
        direction="row"
        ref={ref}
        alignItems="center"
        sx={{
          background: 'white', p: 2, borderRadius: 1, mb: 2, boxShadow: 1,
        }}
      >
        <Stack direction="row" alignItems="center" sx={{ flexWrap: 'wrap' }}>
          <ButtonGroup sx={{ px: 1 }}>
            <Buttons.NewButton onClick={actions.onNew} disabled={!(permissions.canNew && actions.onNew)} />
            <Buttons.EditButton
              onClick={actions.onEdit}
              disabled={!(permissions.canEdit && actions.onEdit)}
            />
            <Buttons.DeleteButton
              onClick={() => setDelOpened(true)}
              disabled={!(permissions.canDelete && actions.onDelete)}
            />
            <Buttons.RefreshButton
              onClick={actions.onRefresh}
            />
          </ButtonGroup>
          <ButtonGroup sx={{ px: 1 }}>
            <Buttons.ExecuteButton
              onClick={actions.onExecute}
              disabled={!(permissions.canExecute && actions.onExecute)}
            />
            <Buttons.UnExecuteButton
              onClick={actions.onUnexecute}
              disabled={!(permissions.canUnexecute && actions.onUnexecute)}
            />
          </ButtonGroup>
          <ButtonGroup sx={{ px: 1 }}>
            <SetPeriodButton value={period} onChange={actions.onSetPeriod} />
            <Buttons.FiltersButton
              onClick={() => actions.onToggleFilterOpened()}
              disabled={!permissions.canFilter}
              color={filterApplied ? 'warning' : 'secondary'}
            />
          </ButtonGroup>
          {children}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ flex: '1 1 auto', px: 1 }}>
          <SearchInput
            onChange={actions.onSearch}
            value={searchString}
            disabled={!permissions.canSearch && !searchString}
          />
        </Stack>
      </Stack>
      <Dialog open={delOpened} onClose={() => setDelOpened(false)}>
        <DialogTitle sx={{ color: 'warning.main' }}>Видалення документу</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Увага. Ця операція незворотня. Ви дійсно бажаєте видалити цей документ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<FontAwesomeIcon icon={faCheck} />}
            color="warning"
            onClick={() => {
              actions.onDelete();
              setDelOpened(false);
            }}
          >
            Так
          </Button>
          <Button
            startIcon={<FontAwesomeIcon icon={faBan} />}
            color="success"
            onClick={() => setDelOpened(false)}
          >
            Ні
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

DocListerCommandPanel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

DocListerCommandPanel.defaultProps = {
  children: null,
};

export default memo(DocListerCommandPanel);
